import { Routine } from 'redux-saga-routines';
import { IEmailTemplate } from '../../common/models/email/IEmailTemplate';
import { candidateSendReminderRoutine, fetchReminderTemplateRoutine } from './routines';

export type SendReminderState = {
  emailTemplate?: IEmailTemplate;
  isLoading: boolean;
  isSending: boolean;
}

const initialState = {
  emailTemplate: undefined,
  isLoading: true,
  isSending: false
};

export const sendReminder = (state: SendReminderState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case fetchReminderTemplateRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      };
    case fetchReminderTemplateRoutine.SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailTemplate: payload
      };
    case fetchReminderTemplateRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      };
    case candidateSendReminderRoutine.TRIGGER:
      return {
        ...state,
        isSending: true
      };
    case candidateSendReminderRoutine.SUCCESS:
    case candidateSendReminderRoutine.FAILURE:
      return {
        ...state,
        isSending: false
      };
    default:
      return state;
  }
};
